import { useTranslation } from 'react-i18next';

import productDev from '@/assets/images/product-dev.png';
import timeMaterial from '@/assets/images/time-material.png';

export default function EngagementModelsInfo() {
  const { t } = useTranslation('engagementModels');

  return (
    <div className="flex flex-col items-center bg-black text-white rounded-b-lg">
      <div className="flex flex-col items-center w-full gap-16 mt-28">
        <div className="section-title">{t('title')}</div>
        <p className="section-content !text-white">{t('content')}</p>

        <div className="flex flex-col md:flex-row justify-center w-full mb-20">
          <div className="flex flex-col items-center min-w-64 w-full md:w-1/2">
            <div className="flex flex-col justify-center items-center w-64">
              <img
                src={timeMaterial}
                alt={t('timeAndMaterialTitle')}
                className="relative size-64 object-cover"
              />
            </div>
            <div className="flex flex-col items-center gap-10 mt-12 text-center">
              <h1 className="uppercase text-2xl font-semibold text-[#e6d29b]">
                {t('timeAndMaterialTitle')}
              </h1>
              <p className="section-content !text-white px-4 max-w-md">
                {t('timeAndMaterialCaption')}
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-start items-center min-w-64 w-full md:w-1/2 mt-40 md:mt-0">
            <div className="flex flex-col justify-center items-center w-64">
              <img
                src={productDev}
                alt={t('productDevelopmentTitle')}
                className="relative size-64 object-cover"
              />
            </div>
            <div className="flex flex-col items-center gap-10 mt-12 text-center">
              <h1 className="uppercase text-2xl font-semibold text-[#e6d29b]">
                {t('productDevelopmentTitle')}
              </h1>
              <p className="section-content !text-white px-4 max-w-md">
                {t('productDevelopmentCaption')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
